<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "SurveyClipboardButton",
    props:{
        textOriginal: {
            type: String,
        },
    },
    computed:{
        ...mapState(
            'surveys',
            {
                language: state => state.currentLanguage,
            }
        ),
    },
    methods:{
        ...mapActions('notifications', {
            showSuccess: 'alertSuccess',
        }),

        getOriginalTranslation() {
            return this.textOriginal
        },

        copyToClipboard() {
            try {
                navigator.clipboard.writeText(this.textOriginal)
                this.alertSuccess('Texte original copié', this.textOriginal)
            } catch (e) {
                console.error('Could not copy text: ', e)
            }
        }
    }
}

</script>

<template>
    <v-tooltip bottom v-if="language !== 'fr' && textOriginal !== '' && textOriginal !== null">
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                color="primary"
                v-on="on"
                @click="copyToClipboard(getOriginalTranslation())"
            >
                <v-icon>mdi-translate</v-icon>
            </v-btn>
        </template>
        <span>Copiez: {{getOriginalTranslation()}}</span>
    </v-tooltip>
</template>

<style scoped>

</style>
